import { useId } from 'react'
import { Area, AreaChart, CartesianGrid, ReferenceLine, ResponsiveContainer, XAxis, YAxis } from 'recharts'
import { tok } from './risk'

export type TrendPoint = { t: number | string; v?: number; proj?: number }

/** Live + projected trend with a threshold line — SCADA telemetry / index history. */
export function AreaTrend({
  data,
  threshold,
  color = tok('--flare'),
  height = 200,
}: {
  data: TrendPoint[]
  threshold?: number
  color?: string
  height?: number
}) {
  const gid = useId().replace(/:/g, '')
  const hasProj = data.some((d) => d.proj != null)
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: -18 }}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor={color} stopOpacity={0.26} />
            <stop offset="1" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid stroke={tok('--border')} strokeOpacity={0.4} vertical={false} />
        <XAxis dataKey="t" hide />
        <YAxis
          tick={{ fill: tok('--faint'), fontSize: 10 }}
          width={30}
          axisLine={false}
          tickLine={false}
          domain={[0, (dataMax: number) => Math.ceil(Math.max(dataMax, threshold ?? 0) * 1.12)]}
        />
        {threshold != null && <ReferenceLine y={threshold} stroke={tok('--flare')} strokeDasharray="3 4" />}
        <Area dataKey="v" stroke={color} strokeWidth={2} fill={`url(#${gid})`} isAnimationActive={false} />
        {hasProj && (
          <Area
            dataKey="proj"
            stroke={tok('--clear')}
            strokeWidth={2}
            strokeDasharray="4 4"
            fill="none"
            isAnimationActive={false}
          />
        )}
      </AreaChart>
    </ResponsiveContainer>
  )
}
